export default {"src":"/_next/static/media/deBridge.542c20ba.svg","height":59,"width":92,"blurWidth":0,"blurHeight":0};